import { Component, Input, OnInit, forwardRef, Inject } from '@angular/core';
import { TranslateService }        from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { CompanyService }  from '../companies/company.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';
import { SessionService }  from '../sessions/session.service';
import { CrudGridService, CrudGridInstance } from '../grids/crud-grid.service';

import { AccountingSettingsModel } from '../companies/models/accounting-settings';
import { CodeTypeModel }           from '../core/models/code-type';
import { ProductCategoryModel }    from './models/product-category';
import { ProductGroupModel }       from './models/product-group';

@Component({
  selector: 'wor-company-lists-product-groups',
  template: require('./company-lists.product-groups.component.html')
})
export class CompanyListsProductGroupsComponent implements OnInit {
  @Input() productGroups: Array<ProductGroupModel> = [];

  accountingSettings: AccountingSettingsModel;
  accounts: Array<CodeTypeModel> = [];
  categories: Array<ProductCategoryModel> = [];
  crudGrid: CrudGridInstance<ProductGroupModel>;
  collapsed = false;
  loadingAccounts = true;
  purchaseAccounts: Array<CodeTypeModel> = [];

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CompanyService))
    public companyService: CompanyService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService: ConfirmService,
    @Inject(forwardRef(() => CrudGridService)) private crudGridService: CrudGridService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    @Inject(forwardRef(() => SessionService))
    public sessionService: SessionService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.crudGrid = this.crudGridService.create<ProductGroupModel>();
    this.crudGrid.data = this.productGroups;
    this.getSettings();
  }

  getSettings(): void {
    this.companyService.getAllAccounts()
      .then((accounts) => {
        this.accounts         = accounts.sale;
        this.purchaseAccounts = accounts.purchase;
        return accounts;
      })
      .then(() => this.companyService.getAccountingSettings())
      .then((settings: AccountingSettingsModel) => {
        this.accountingSettings = settings;
      })
      .then(() => this.apiService.get('/product_categories/product_category_list', 'true'))
      .then((categories: Array<ProductCategoryModel>) => {
        this.categories = categories;
      })
      .finally(() => {
        this.loadingAccounts = false;
      });
  }

  saveRow(group: ProductGroupModel, index: number): void {
    const method = group.created_on ? 'patch' : 'post';
    const url    = group.created_on ? '/product_group' : '/product_groups';

    this.apiService[method](url, group, 'product_group')
      .then(savedGroup => {
        Object.assign(group, savedGroup);
        this.crudGrid.toggleEditMode(group, index);
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.PRODUCT_GROUP'), 'success');
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }

  removeRow(group: ProductGroupModel, index: number): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_PRODUCT_GROUP'))
      .then(() => this.crudGrid.removeRow(group, index, '/product_group', 'name'))
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.PRODUCT_GROUP'), 'success');
        this.crudGrid.data.splice(index, 1);
      });
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }
}
